export default {
  FETCH_COMMENTS: 'comments/FETCH_COMMENTS',
  DELETE_COMMENT: 'comments/DELETE_COMMENT',
  SET_STATE: 'comments/SET_STATE',
}
